import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "@/App";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processSession = async () => {
      try {
        // Extract session_id from URL - check both hash and full URL
        const fullUrl = window.location.href;
        const hash = window.location.hash;
        
        let sessionId = null;
        
        // Try to find session_id in hash first
        const hashMatch = hash.match(/session_id=([^&]+)/);
        if (hashMatch) {
          sessionId = hashMatch[1];
        }
        
        // Fallback: try to find in full URL (some browsers/PWAs handle it differently)
        if (!sessionId) {
          const urlMatch = fullUrl.match(/session_id=([^&]+)/);
          if (urlMatch) {
            sessionId = urlMatch[1];
          }
        }
        
        if (!sessionId) {
          console.error("No session_id found in URL:", fullUrl);
          navigate("/");
          return;
        }
        
        if (process.env.NODE_ENV !== "production") console.log("Processing session_id:", sessionId.substring(0, 10) + "...");
        
        // Get referral code if stored during landing
        const referralCode = localStorage.getItem("savecation_referral_code") || "";
        
        // Exchange session_id for user data (with referral code)
        const response = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId, referral_code: referralCode })
        });
        
        // Clear the stored referral code
        localStorage.removeItem("savecation_referral_code");
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Auth failed:", errorText);
          throw new Error("Failed to authenticate");
        }
        
        const user = await response.json();
        if (process.env.NODE_ENV !== "production") console.log("Auth successful, user:", user.email);
        
        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        
        // Navigate based on onboarding status
        if (user.onboarding_completed) {
          navigate("/dashboard", { state: { user }, replace: true });
        } else {
          navigate("/onboarding", { state: { user }, replace: true });
        }
      } catch (error) {
        console.error("Auth error:", error);
        navigate("/");
      }
    };
    
    processSession();
  }, [navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-sky-50 to-white">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-sky-100 flex items-center justify-center animate-pulse">
          <svg className="w-8 h-8 text-sky-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-lg text-slate-600 font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
